module.exports = __webpack_public_path__ + "assets/img/sex2.2e6979a5.svg";